// assets/custom-scripts.js
document.addEventListener("DOMContentLoaded", () => {

  /**
   * Dispatches the CartAddEvent to sync with the cart drawer
   * @param {Object} cartData - The product data added to cart
   * @param {Object} sections - The updated HTML sections
   * @param {HTMLElement} form - The form that triggered the action
   */
  async function dispatchCartAddEvent(cartData, form) {
    try {
      // Get updated sections for the cart drawer
      const sectionsResponse = await fetch("/?sections=cart-drawer,header");
      const sections = await sectionsResponse.json();

      // Dispatch the native theme CartAddEvent
      const eventData = {
        resource: cartData,
        sourceId: form?.id || "quick-buy-form",
        data: {
          source: "quick-buy",
          productId: cartData.product_id,
          variantId: cartData.variant_id,
          itemCount: cartData.quantity,
          sections: sections
        }
      };

      const cartAddEvent = new CustomEvent("theme:cart-update", {
        bubbles: true,
        detail: eventData
      });

      document.dispatchEvent(cartAddEvent);

    } catch (error) {
      console.error('Error dispatching cart event:', error);
    }
  }

  /**
   * Handles the successful quick buy response
   * @param {Object} cartData - The cart data after adding the product
   * @param {HTMLFormElement} form - The form that triggered the action
   */
  async function handleQuickBuySuccess(cartData, form) {
    // Sync with the cart drawer
    await dispatchCartAddEvent(cartData, form);

    // Update cart UI
    updateCartUI();

    // Dispatch Rebuy event if needed
    document.dispatchEvent(
      new CustomEvent("rebuy:cart.change", {
        detail: { cart: cartData },
      })
    );
  }

  // 2. Quick Buy Logic
  function initializeQuickBuy() {
    const quickBuyButtons = document.querySelectorAll(".quick-buy__button");
    quickBuyButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const productCard = event.target.closest(".product-card");
        const quickBuyContainer = productCard.querySelector(
          ".quick-buy-container"
        );

        // Toggle visibility
        quickBuyContainer?.classList?.toggle("is-visible");
      });
    });

    // Handle form submission with AJAX to prevent page reload
    const quickBuyForms = document.querySelectorAll(".quick-buy__form");
    quickBuyForms.forEach((form) => {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const formData = new FormData(form);

        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            body: formData,
          });

          const cartData = await response.json();

          if (cartData.status === 422) {
            // Handle validation errors, e.g., out of stock
            throw new Error(cartData.description);
          }

          // Handle successful quick buy
          await handleQuickBuySuccess(cartData, form);

          // Close the quick view panel after adding to cart
          const productCard = form.closest('.product-card');
          if (productCard) {
            productCard.classList.remove('is-quick-view-visible');
          }

        } catch (error) {
          console.error("Error adding to cart:", error);
          alert(error.message || "Error adding product to cart");
        }
      });
    });
  }

  setTimeout(() => {
    initializeQuickBuy();
  }, 2000)

  // Re-initialize scripts when content changes (e.g., infinite scroll, filters)
  document.body.addEventListener("shopify:section:load", () => {
    initializeQuickBuy();
  });
});

/**
 * Updates cart components using the Section Rendering API.
 * This is the most robust and recommended method.
 */
async function updateCartUI() {
  try {
    // Request the rendered HTML of the header section from Shopify
    // Replace 'header' with your section name if different
    const response = await fetch("/?sections=header");
    const sections = await response.json();

    if (sections["header"]) {
      const newHeaderHTML = new DOMParser().parseFromString(
        sections["header"],
        "text/html"
      );

      // Elements to update
      const newCartBubbleHTML =
        newHeaderHTML.querySelector("#cart-icon-bubble")?.innerHTML;
      const oldCartBubbleElement = document.querySelector("#cart-icon-bubble");

      // Update the counter/bubble
      if (oldCartBubbleElement && newCartBubbleHTML !== undefined) {
        oldCartBubbleElement.innerHTML = newCartBubbleHTML;
      }

      // (Optional but useful) Update the drawer counter if it exists
      const newDrawerCountHTML = newHeaderHTML.querySelector(
        "#cart-drawer-count-bubble"
      )?.innerHTML;
      const oldDrawerCountElement = document.querySelector(
        "#cart-drawer-count-bubble"
      );

      if (oldDrawerCountElement && newDrawerCountHTML !== undefined) {
        oldDrawerCountElement.innerHTML = newDrawerCountHTML;
      }
    }
  } catch (error) {
    console.error("Failed to update cart UI:", error);
  }
}
